// extracted by mini-css-extract-plugin
module.exports = {"container":"loading_container__0H355","loaderText":"loading_loaderText__f0t5Y","loading-text":"loading_loading-text__nthjb"};